<template>
  <div class="list-container" :style="{height: height}">
    <div class="toolbar">
      <el-input placeholder="查询关键字" v-model="keyword" :clearable="true" :style="{ width:'250px',float: 'right'}">
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </div>
    <el-table :data="ordFreightAnalyseRiderList"
              highlight-current-row ref="table"
              v-loading="loading"
              :max-height="tableMaxHeight"
              @sort-change="handleSortChange">
      <el-table-column label="序号" type="index" align="center" width="60px" :index="getIndex"></el-table-column>
      <el-table-column label="门店名称" align="left" width="250px" prop="sStore" sortable="custom"></el-table-column>
      <el-table-column label="姓名" align="left" width="100px" prop="sRider" sortable="custom"></el-table-column>
      <el-table-column label="特殊人群" align="center" width="80px">
        <template #default="scope">
          {{ getSpecial(scope.row.bSpecial) }}
        </template>
      </el-table-column>
      <el-table-column label="接单量" align="left" width="100px" prop="totalReceive" sortable="custom"></el-table-column>
      <el-table-column label="配送量" align="left" width="100px" prop="totalDelivery" sortable="custom"></el-table-column>
      <el-table-column label="取消量" align="left" width="100px" prop="totalCancel" sortable="custom"></el-table-column>
      <el-table-column label="接单率" align="left" width="100px" prop="receiveRate" :formatter="rateFormatter" sortable="custom"></el-table-column>
      <el-table-column label="平均接单时间" align="left" width="120px" prop="avgReceiveTime" :formatter="timeFormatter" sortable="custom"></el-table-column>
      <el-table-column label="运费合计" align="left" width="100px" prop="totalDeliveryCost" :formatter="priceFormatter" sortable="custom"></el-table-column>
      <el-table-column label="小费合计" align="left" width="100px" prop="totalDispatchCost" :formatter="priceFormatter" sortable="custom"></el-table-column>
      <el-table-column label="运费总计" align="left" width="100px" prop="totalCost" :formatter="priceFormatter" sortable="custom"></el-table-column>
      <el-table-column label="平均配送距离" align="left" width="120px" prop="avgDistance" sortable="custom"></el-table-column>
      <el-table-column label="平均时长" align="left" width="120px" prop="avgDeliveryTime" :formatter="timeFormatter" sortable="custom"></el-table-column>
      <el-table-column label="平均运费" align="left" width="100px" prop="avgDeliveryCost" :formatter="priceFormatter" sortable="custom"></el-table-column>
      <el-table-column label="评价" align="center" width="80px" prop="totalAppraise" sortable="custom"></el-table-column>
      <el-table-column label="准时率" align="center" width="80px" prop="punctualityRate" :formatter="rateFormatter" sortable="custom"></el-table-column>
      <el-table-column fixed="right" align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="view(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :layout="pageLayout"
      :total="total"
      :current-page="pageNum"
      :page-sizes="pageSelect"
      :page-size="pageSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :style="{marginTop: '15px'}">
    </el-pagination>
  </div>
</template>

<script>
import {getOrdFreightAnalyseRiderList} from "@/api/delivery/delivery";
import {specialMap} from "@/utils/deliveryMap";
import {formatSeconds, formatTime} from "@/utils/utils";

export default {
  name: "SelfDeliveryRiderEfficiencyList",
  components: {},
  props: {
    selectedStore: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      height: document.documentElement.clientHeight - 142 + "px",
      tableMaxHeight: document.documentElement.clientHeight - 260,
      currentSid:'',
      keyword:'',
      rStores:[],
      ordFreightAnalyseRiderList:[],
      loading:false,
      total: 0, //总条数
      pageNum: 1, //当前页
      pageSize: 10, //每页显示条数
      pageSelect: [10, 20, 30, 50],
      pageLayout:"prev, pager, next,jumper,total,sizes",
      showViewRiderDetail: false,
      orderByColumn:'',
      isAsc:'',
    };
  },
  created() {
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  computed: {
    getSpecial() {
      return function(bStatus) {
        return specialMap[bStatus] || '未知';
      };
    },
  },
  methods: {
    getOrdFreightAnalyseRiderList() {
      let params = {
        type:2,
        search:this.keyword,
        rStores:this.rStores,
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        orderByColumn: this.orderByColumn,
        isAsc: this.isAsc,
      }
      this.loading = true;
      getOrdFreightAnalyseRiderList(params).then(result => {
        if (result) {
          this.ordFreightAnalyseRiderList = result.rows;
          this.total = result.total;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSortChange({ prop, order }) {
      if (order) {
        this.orderByColumn = prop;
        this.isAsc = order === 'ascending' ? 'asc' : 'desc';
        this.getOrdFreightAnalyseRiderList();
      }else{
        this.orderByColumn = '';
        this.isAsc = '';
        this.getOrdFreightAnalyseRiderList();
      }
    },
    // 查询
    search(){
      this.pageNum = 1;
      this.getOrdFreightAnalyseRiderList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getOrdFreightAnalyseRiderList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getOrdFreightAnalyseRiderList();
    },
    view(item){
      this.$emit('open',{sid:item.rRider,cName:item.sRider});
    },
    getIndex(rowIndex) {
      return (this.pageNum - 1) * this.pageSize + rowIndex +1;
    },
    priceFormatter(row, column, cellValue) {
      return cellValue?'￥'+cellValue:'';
    },
    rateFormatter(row, column, cellValue) {
      return cellValue?(parseFloat(cellValue)*100).toFixed(0)+'%':'';
    },
    timeFormatter(row, column, cellValue) {
      return formatSeconds(cellValue);
    },
    dateFormatter(row, column, cellValue) {
      return cellValue?formatTime(cellValue,"YYYY-MM-DD HH:mm"):'';
    },
    handleKeydown(event) {
      if (event.key === 'Enter' || event.keyCode === 13) {
        this.pageNum = 1;
        this.getOrdFreightAnalyseRiderList();
      }
    },
  },
  watch: {
    selectedStore(newVal) {
      this.rStores = newVal;
      this.pageNum = 1;
      this.getOrdFreightAnalyseRiderList();
    },
  },
};
</script>

<style lang="scss" scoped>
.list-container{
  width: 100%;
  .toolbar{
    width: 100%;
    height: 50px;
  }
}
</style>
